import { closeModal, openModal } from "./store"

export type ModalOptions = {
  width?: string
}

// oxlint-disable-next-line no-explicit-any
export type BaseModalComponentProps<T = any> = {
  onClose: (val: T) => void
}

/**
 * Callback types provided for descriptive type-hints
 */
export type OpenModal<P extends BaseModalComponentProps> =
  P extends Record<string, never>
    ? () => void
    : (
        props: Omit<P, "onClose"> & {
          onClose?: P["onClose"]
        },
      ) => void

export type CloseModal = () => void

/**
 * Example
 * const modal = createModal(ModalComponent)
 *
 * modal.open(props)
 *
 */
export const createModal = <P extends BaseModalComponentProps>(
  component: React.FunctionComponent<P>,
  options?: ModalOptions,
): {
  open: OpenModal<P>
  close: CloseModal
} => {
  const uid = crypto.randomUUID()

  const open = (props: P) => {
    openModal({
      Component: component,
      props,
      uid: uid,
      width: options?.width,
    })
  }
  //To close the modal we remove ot from the modal store
  const close: CloseModal = () => {
    closeModal(uid)
  }

  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  return { open: open as OpenModal<P>, close }
}
